import { Chip, Tooltip } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import AppModal from "../../components/AppModal";
import UploadClaimAttachmentModal from "./components/UploadClaimAttachmentModal";
import UploadClaimModal from "./UploadClaimModal";
import { FileUpload } from "@mui/icons-material";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import ConformationModal from "../../components/ConformationModal";
import ClaimUploadErrorModal from "./ClaimUploadErrorModal";
import GenerateModal from "./GenerateModal";
import { useTranslation } from "react-i18next";
import ClaimUploadListSkeleton from "../../common/ClaimUploadListSkeleton";
import AppButton from "../../shared/AppButton";
import AppTable from "../../shared/AppTable";

export default function ClaimUploadList() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [selectedItem, setSeelectedItem] = useState(null);
  const [openGenerateModal, setOpenGenerateModal] = useState(false);
  const [generatePayload, setGeneratePayload] = useState({
    id: null,
    ucaf: false,
    invoice: false,
  });
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [currentReference, setCurrentReference] = useState(null);
  const [loadingFile, setLoadingFile] = useState(false);
  const [uploadData, setUploadData] = useState([]);
  const [showUploadAttachmentModal, setShowUploadAttachmentModal] =
    useState(false);
  const [showUploadClaimModal, setShowUploadClaimModal] = useState(false);
  const [generateLoading, setGenerateLoading] = useState(false);
  const [currentUploadData, setCurrentUploadData] = useState(null);

  const handleOpenGenerateModal = () => setOpenGenerateModal(true);
  const handleCloseGenerateModal = () => setOpenGenerateModal(false);

  const getUploadClaimHistory = async () => {
    const token = localStorage.getItem("token");
    const tokenWithoutQuotes = token.replace(/"/g, "");
    if (!token) {
      console.error("Token not found in local storage.");
      return;
    }
    try {
      setLoadingFile(true);
      const response = await axios.get(
        "https://api.supergitsa.com/api/tasks?type=excel upload",
        { headers: { Authorization: `Bearer ${tokenWithoutQuotes}` } },
      );
      setLoadingFile(false);
      setUploadData(response?.data?.data);
    } catch (error) {
      setLoadingFile(false);
      console.log(error);
      toast.error(error?.response?.data?.error);
    }
  };

  useEffect(() => {
    getUploadClaimHistory();
  }, []);

  const handleprocess = async (claimRefference) => {
    const token = localStorage.getItem("token");
    const tokenWithoutQuotes = token.replace(/"/g, "");
    if (!token) {
      console.error("Token not found in local storage.");
      return;
    }
    try {
      setLoadingFile(true);
      const response = await axios.post(
        `https://api.supergitsa.com/api/claim/excel/process?excel_id=${claimRefference}`,
        {},
        { headers: { Authorization: `Bearer ${tokenWithoutQuotes}` } },
      );
      setLoadingFile(false);
      toast.success(response?.data?.message);
    } catch (error) {
      setLoadingFile(false);
      console.log(error);
      toast.error(error?.response?.data?.error);
    }
  };

  const handleDelete = async () => {
    const token = localStorage.getItem("token");
    const tokenWithoutQuotes = token ? token.replace(/"/g, "") : null;
    if (!tokenWithoutQuotes) {
      console.error("Token not found in local storage.");
      toast.error("Authentication token not found.");
      return;
    }
    try {
      setLoadingFile(true);
      const response = await axios.delete(
        `https://api.supergitsa.com/api/claim/excel/delete?excel_id=${currentReference}`,
        { headers: { Authorization: `Bearer ${tokenWithoutQuotes}` } },
      );
      setShowConfirmModal(false);
      setLoadingFile(false);
      getUploadClaimHistory();
      toast.success(response?.data?.message);
    } catch (error) {
      setLoadingFile(false);
      console.error(error);
      toast.error(error?.response?.data?.error || "An error occurred.");
    }
  };

  const handleDownloadClick = () => {
    const link = document.createElement("a");
    link.href = "/claimSample.xlsx";
    link.download = "claimSample.xlsx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleOpenErrorModal = (el) => {
    setSeelectedItem(el);
    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  const formatDateTime = (time) => {
    if (!time) return "";
    const sanitizedTime = time.replace(/\s\+\d{4}$/, "");
    const dateTime = new Date(sanitizedTime);
    if (isNaN(dateTime)) return "Invalid date";
    const dateOnly = dateTime.toLocaleDateString("en-GB");
    const timeOnly = dateTime.toLocaleTimeString(navigator.language, {
      hour: "2-digit",
      minute: "2-digit",
    });
    return `${dateOnly} <br /> ${timeOnly}`;
  };

  const handleGenerateClick = async (data) => {
    try {
      setGenerateLoading(true);
      const token = localStorage.getItem("token");
      const tokenWithoutQuotes = token ? token.replace(/"/g, "") : null;
      if (!tokenWithoutQuotes) {
        toast.error("Authentication token not found.");
        return;
      }
      const response = await axios.post(
        `https://api.supergitsa.com/api/claim/excel/attachment/generate?excel_id=${data?.id}`,
        { invoice: data?.invoice, ucaf: data?.ucaf },
        { headers: { Authorization: `Bearer ${tokenWithoutQuotes}` } },
      );
      toast.success(response?.data?.message);
      setGenerateLoading(false);
    } catch (e) {
      setGenerateLoading(false);
      console.error("Error:", e);
    }
  };

  const getStatusStyles = (isComplete) => {
    if (isComplete) return { bg: "#dcfce7", text: "#15803d" };
    return { bg: "#fee2e2", text: "#b91c1c" };
  };

  const columns = [
    {
      header: t("Status"),
      render: (row) => {
        const isComplete =
          row?.Total !== 0 &&
          row?.Total !== null &&
          row?.Total === row?.Completed;
        const styles = getStatusStyles(isComplete);
        return (
          <Chip
            label={isComplete ? t("Complete") : t("Incomplete")}
            size="small"
            sx={{
              backgroundColor: styles.bg,
              color: styles.text,
              fontWeight: "700",
              fontSize: "10px",
              borderRadius: "6px",
              textTransform: "uppercase",
              height: 20,
            }}
          />
        );
      },
    },
    {
      header: t("Care Team"),
      render: (row) => row?.Stats?.CareTeam || "---",
    },
    { header: t("Task Type"), field: "TaskType" },
    { header: t("Claim Info"), render: (row) => row?.Stats?.ClaimInfo },
    { header: t("Reference No"), field: "ReferenceNo" },
    { header: t("Diagnosis"), render: (row) => row?.Stats?.Diagnosis || "---" },
    { header: t("Attachments"), render: (row) => row?.Attachments || "---" },
    { header: t("Item"), render: (row) => row?.Stats?.Item || "---" },
    {
      header: t("Supporting Info  "),
      render: (row) => row?.Stats?.SupportingInfo || "---",
    },
    { header: t("Total"), field: "Total" },
    { header: t("Completed"), field: "Completed" },
    {
      header: t("Created At"),
      render: (row) => (
        <span
          dangerouslySetInnerHTML={{ __html: formatDateTime(row?.CreatedAt) }}
        />
      ),
    },
  ];

  return (
    <>
      {loadingFile ? (
        <ClaimUploadListSkeleton />
      ) : (
        <div className="pre_auth_container !p-0">
          {/* Action Buttons */}
          <div className="flex justify-between gap-1.5 flex-col sm:flex-row mb-2">
            <div className="w-full sm:w-[calc(100%-150px)]">
              <span className="font-semibold text-black/70 text-lg ">
                {t("Upload History")}
                <span className=" text-lg ml-1">
                  ({uploadData?.length || 0}{" "}
                  <span className="text-xs font-bold italic">
                    {t("Entries")}
                  </span>
                  )
                </span>
              </span>
            </div>
            <div className="flex flex-col sm:flex-row gap-2">
              <AppButton
                label={t("Download Sample File")}
                variant="outlined"
                onClick={handleDownloadClick}
                isLoading={loadingFile}
                startIcon={<FileDownloadOutlinedIcon />}
                className="!border-primary !text-primary hover:!bg-primary/10"
              />
              <AppButton
                label={t("Upload Excel")}
                onClick={() => setShowUploadClaimModal(true)}
                startIcon={<FileUpload />}
              />
            </div>
          </div>
          {/* Table */}
          <AppTable
            cellClassName="!py-0"
            actioncellClassName="!py-0"
            columns={columns}
            data={uploadData}
            loading={loadingFile}
            LoaderComponent={<ClaimUploadListSkeleton />}
            onErrorLogs={(row) => handleOpenErrorModal(row)}
            onAttachment={(row) => {
              setCurrentUploadData(row);
              setShowUploadAttachmentModal(true);
            }}
            onDelete={(row) => {
              setCurrentReference(row.ReferenceNo);
              setShowConfirmModal(true);
            }}
            onGenerate={(row) => {
              setGeneratePayload((prev) => ({ ...prev, id: row.ReferenceNo }));
              setOpenGenerateModal(true);
            }}
            onProcess={(row) => handleprocess(row.ReferenceNo)}
          />
        </div>
      )}

      <ConformationModal
        open={showConfirmModal}
        setOpen={setShowConfirmModal}
        onDelete={handleDelete}
        text={t("Delete")}
      />
      <GenerateModal
        generatePayload={generatePayload}
        setGeneratePayload={setGeneratePayload}
        handleClick={handleGenerateClick}
        open={openGenerateModal}
        handleClose={handleCloseGenerateModal}
        handleOpen={handleOpenGenerateModal}
      />
      <UploadClaimAttachmentModal
        showUploadAttachmentModal={showUploadAttachmentModal}
        setShowUploadAttachmentModal={setShowUploadAttachmentModal}
        currentUploadData={currentUploadData}
        setCurrentUploadData={setCurrentUploadData}
      />
      <UploadClaimModal
        showUploadClaimModal={showUploadClaimModal}
        setShowUploadClaimModal={setShowUploadClaimModal}
        getUploadClaimHistory={getUploadClaimHistory}
      />
      <ClaimUploadErrorModal
        setOpen={setOpen}
        open={open}
        handleClose={handleClose}
        selectedItem={selectedItem}
      />
    </>
  );
}
